import { render, staticRenderFns } from "./ButtonOutlineBox.vue?vue&type=template&id=d6bf7556&"
import script from "./ButtonOutlineBox.vue?vue&type=script&lang=js&"
export * from "./ButtonOutlineBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports